import { useUser } from "src/common/context/userContextUtils";
import { COMPANYADMIN } from "src/common/service/users";

export const useCanAddDataSource = (
	companyDomainId: string | number,
): boolean => {
	const { hasPermissions } = useUser();
	return hasPermissions(
		companyDomainId,
		["DataSieUpload", COMPANYADMIN],
		"any",
	);
};
